import { navigateToSalesPortalRoute } from '@/experiences/sales-portal/sales-portal-route-config';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { useCallback } from 'react';
import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';
import { useNavigation } from '@react-navigation/native';
import type { SalesPortalInsightsStackParams } from '@/navigators/types';
import type { StackNavigationProp } from '@react-navigation/stack';

/**
 * Phones push within the Insights stack so back returns to the feed;
 * wider layouts resolve the route to its parent tab.
 */
export const useAccountDetailPress = (
  supplierUUID: string,
): ((restaurantUUID: string) => void) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalInsightsStackParams>>();
  const isMobileBottomNavLayout = useIsMobileBottomNavLayout();

  return useCallback(
    (restaurantUUID: string) => {
      const params = { restaurantUUID, supplierUUID };

      if (isMobileBottomNavLayout) {
        navigation.push(SALES_PORTAL_ROUTES.AccountDetail, params);
        return;
      }

      navigateToSalesPortalRoute(
        navigation,
        SALES_PORTAL_ROUTES.AccountDetail,
        params,
      );
    },
    [isMobileBottomNavLayout, navigation, supplierUUID],
  );
};
